import styled from "styled-components"

export default function Spinner({ width = 40, height = 40, size = 4, color }) {
  return (
    <SpinnerBlock width={width} height={height}>
      <SpinnerStyle size={size}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </SpinnerStyle>
    </SpinnerBlock>
  )
}

const SpinnerBlock = styled.div`
  height: calc(100vw * (${({ width }) => width} / 375));
  width: calc(100vw * (${({ height }) => height} / 375));
`

const SpinnerStyle = styled.div`
  display: inline-block;
  position: relative;
  width: 100%;
  height: 100%;
  & div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    border: ${({ size }) => size}px solid #fece37;
    border-radius: 50%;
    animation: circle-animation 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #fece37 transparent transparent transparent;
  }

  & div:nth-child(1) {
    animation-delay: -0.45s;
  }
  & div:nth-child(2) {
    animation-delay: -0.3s;
  }
  & div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes circle-animation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`
